import "../stylesheet/index.scss";

import { Search } from "components/search";

import { getElementById } from "utils";

const container = getElementById("search");
const component = new Search();

container.replaceChildren(component.render());
